import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function usePrivacy() {
  const route = useRoute()
  const router = useRouter()

  const isBlurred = computed(() => route.query.blur === '1')

  const toggleBlur = async () => {
    const query = { ...route.query }

    if (isBlurred.value) {
      delete query.blur
    } else {
      query.blur = '1'
    }

    await router.replace({
      path: route.path,
      query
    })
  }

  return {
    isBlurred,
    toggleBlur
  }
}
